import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../i18n'
import { Button } from '../ui/Button'
import { featureFlags } from '../../config/featureFlags'
import type { InformationSystemExecutiveSummary } from '../../services/enterpriseOperationalUxApi'
import { mapInformationSystemToUnifiedContext } from '../../utils/unifiedExecutiveContextMappers'
import ExecutiveOperationalContextPanel from './context/ExecutiveOperationalContextPanel'
import assetStyles from '../../styles/components/assets/AssetsInformationSystems.module.scss'

type Props = {
  summary: InformationSystemExecutiveSummary | null
  systemName: string
}

export default function InformationSystemExecutivePanel({ summary, systemName }: Props) {
  const { t } = useI18n()
  const navigate = useNavigate()

  if (!summary) {
    return null
  }

  const context = mapInformationSystemToUnifiedContext(summary, systemName)

  const footerActions = (
    <>
      {featureFlags.EXECUTIVE_GOVERNANCE_V1 && summary.impactedStandards?.[0] ? (
        <Button
          type="button"
          size="small"
          color="outline"
          onClick={() =>
            navigate(
              `/compliance-center/executive-governance/${encodeURIComponent(summary.impactedStandards[0])}`,
            )
          }
        >
          {t('enterpriseOperationalUx.openExecutiveContext', 'Open executive context')}
        </Button>
      ) : null}
      {featureFlags.COMPLIANCE_RUNTIME_V1 ? (
        <Button
          type="button"
          size="small"
          color="outline"
          onClick={() => navigate('/compliance-center/operational-events')}
        >
          {t('enterpriseOperationalUx.openRuntimeEvents', 'Runtime events')}
        </Button>
      ) : null}
    </>
  )

  return (
    <div className={assetStyles.contextSectionBody}>
      <ExecutiveOperationalContextPanel
        context={context}
        title={systemName}
        mode="compact"
        footerActions={footerActions}
      />
    </div>
  )
}
